import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createImageMockSource } from '@/mocks/create-image-mock-source';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftSalesManagementDetailResponse } from '@/repositories/generated';

const response: GiftSalesManagementDetailResponse = {
  giftSalesManagementId: '0018',
  giftSalesManagementName: '青森市商品券（第3弾）',
  giftBusinessId: '001',
  salesStatus: 'ON_SALE',
  salesStartsAt: '2025-05-01T00:00:00+09:00',
  salesEndsAt: '2025-07-31T00:00:00+09:00',
  remarks: '（運営者メモ）広報誌への掲載は7月号を予定。コールセンター対応は9月まで。',
  salesInfo: {
    entryStartsAt: '2025-04-01T00:00:00+09:00',
    entryEndsAt: '2025-04-30T23:59:59+09:00',
    entryBaseUrl: 'https://example.com/entry',
    entryDescription: 'あ'.repeat(2000),
    salesCount: 15000,
    salesPerAmount: 10000,
    premiumRate: 0.25,
    totalGrantedPerAmount: 12500,
    purchaseAvailableCountPerUser: 2,
    giftSalesManagementImagePath1: createImageMockSource('販売管理画像1', { width: 750, height: 220 }),
    giftSalesManagementImagePath2: createImageMockSource('販売管理画像2', { width: 750, height: 220 }),
    giftSalesManagementExplanation: 'い'.repeat(2000),
    websiteUrl: 'https://example.com/website',
    expiresStartsAt: '2025-08-01T00:00:00+09:00',
    expiresEndsAt: '2025-10-31T23:59:59+09:00',
    customField1: 'う'.repeat(2000),
    customField2: 'え'.repeat(2000),
    customField3: 'お'.repeat(2000),
    customField4: 'か'.repeat(2000),
    customField5: 'き'.repeat(2000),
    createdAt: '2025-05-12T17:41:00+09:00',
    updatedAt: '2025-05-12T17:41:00+09:00',
  },
  tickets: [
    {
      giftTicketId: '0055',
      giftTicketName: '青券（中小・一般店のみで利用可）',
      totalAmount: 7500,
      prepaidValue: 6000,
      bonusValue: 1500,
    },
    {
      giftTicketId: '0777',
      giftTicketName: '赤券（大型店・一般店で利用可能）',
      totalAmount: 5000,
      prepaidValue: 4000,
      bonusValue: 1000,
    },
  ],
};

export const giftSalesManagementDetail = http.get(
  createMockEndpoint('/gift_sales_management/:id'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
